const profileStatsStyles = (theme) => ({
    statItem: {
      width: "100%",
      py: 2,
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    label: {
      fontSize: "14px",
      color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.6)",
    },
    value: {
      fontSize: "16px",
      fontWeight: 500,
      color: theme.palette.mode === "dark" ? "#fff" : "#333",
    },
    tooltipContainer: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
    },
    tooltipValue: {
      fontSize: "16px",
      fontWeight: 500,
      color: theme.palette.mode === "dark" ? "#fff" : "#333",
      textDecoration: "underline",
    },
    iconButton: {
      color: theme.palette.mode === "dark" ? "#fff" : "#333",
      ml: 0.5,
      p: 0.5,
    },
  });
  
  export default profileStatsStyles;
  